import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxDropDownBoxModule, DxButtonModule, DxCheckBoxModule, DxDropDownButtonModule, DxNumberBoxModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxSwitchModule, DxTextAreaModule, DxTextBoxModule, DxTreeViewModule, DxTagBoxModule, DxDataGridModule, DxDateBoxModule, DxRadioGroupModule, DxAccordionModule,
    DxTabPanelModule,
    DxAutocompleteModule,
    DxTabsModule,
    DxTemplateModule,
    DxToolbarModule,
    DxSortableModule,
    DxDiagramModule,
    DxFileUploaderModule,
    DxTreeListModule,
    DxHtmlEditorModule,
    DxTooltipModule,
    DxSpeedDialActionModule,
    DxListModule
} from 'devextreme-angular';
import { SystemControllerModule } from 'src/app/pages/estimation/system-controller/system-controller.module';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { AIestimateComponent } from './ai-estimate.component';



@NgModule({
    declarations: [AIestimateComponent],
    imports: [
        CommonModule,
        MdbGlobalModule,
        DxTreeViewModule,
        DxButtonModule,
        DxDropDownButtonModule,
        DxPopupModule,
        DxScrollViewModule,
        DxCheckBoxModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxTextAreaModule,
        DxSelectBoxModule,
        DxSwitchModule,
        DxDropDownBoxModule,
        SystemControllerModule,
        DxTagBoxModule,
        DxDataGridModule,
        DxDateBoxModule,
        DxRadioGroupModule,
        DxAccordionModule,
        DxTabPanelModule,
        DxAutocompleteModule,
        DxTabsModule,
        DxTemplateModule,
        DxToolbarModule,
        DxSortableModule,
        DxDiagramModule,
        DxFileUploaderModule,
        DxTreeListModule,
        DxHtmlEditorModule,
        DxTooltipModule,
        DxSpeedDialActionModule,
        DxListModule

    ],
    exports: [AIestimateComponent]
})
export class AIestimateModule { }
